import type { TImporterState } from '@feathr/blackbox';

/*
 * A failed import is not a dead end: the usual recovery is to re-upload a
 * corrected file and run it again, so the wizard stays editable and the
 * Import/Save actions stay enabled in that state as well as in 'draft'.
 * 'pending' is in flight and 'complete' is done, so both stay locked.
 */
const EDITABLE_STATES = new Set<TImporterState>(['draft', 'failed']);

export function isImporterEditable(state?: TImporterState): boolean {
  return !!state && EDITABLE_STATES.has(state);
}
